import axios from "../../config/axiosConfig";

export default class PaiementService {
  getAllPaiement = async () => {
    try {
      const response = axios.get("/paiements");
      return response;
    } catch (error) {
      throw new Error("Erreur  : " + error.message);
    }
  };
}
